import { render, staticRenderFns } from "./TheRecipientsAreaEmailRestrictions.vue?vue&type=template&id=462e06c9&scoped=true"
import script from "./TheRecipientsAreaEmailRestrictions.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAreaEmailRestrictions.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAreaEmailRestrictions.vue?vue&type=style&index=0&id=462e06c9&prod&lang=scss&scoped=true"
import style1 from "./TheRecipientsAreaEmailRestrictions.vue?vue&type=style&index=1&id=462e06c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e06c9",
  null
  
)

export default component.exports